<template>
  <v-card class="widget-card" :class="color">
    <v-card-text class="pa-0 w-100">
      <v-container class="pa-0">
        <div class="d-flex justify-center align-center">
          <div class="flex pl-10">
            <div class="text-left">
              <div class="title">{{ title }}</div>
              <span class="subtitle">{{ subTitle }}</span>
            </div>
          </div>
          <div class="flex">
            <v-icon size="45px" color="white" style="opacity: 0.8;">{{
              icon
            }}</v-icon>
          </div>
        </div>
      </v-container>
      <div>
        <dentoholic class="absolute detohlic--img" :color="variant" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Dentoholic from "@/components/Dentoholic.vue";
export default {
  props: {
    subTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  components: {
    Dentoholic
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.widget-card {
  border-radius: 0px !important;
  box-shadow: -1px 12px 23px rgba(0, 0, 0, 0.107654);
  width: 100%;
  padding: 4.2rem 0;
  .title {
    font-family: Gotham-Medium !important;
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 20px !important;
    line-height: 30px !important;
    letter-spacing: 0.04em !important;
    color: #fff;
  }
  .subtitle {
    font-family: Gotham-Book !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 20px !important;
    letter-spacing: 0.04em !important;
    color: #ffffff !important;
  }
  .detohlic--img {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
